









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { IChunkAttachment } from '@/interfaces/IChunkAttachment';


@Component
export default class MultiChunkUploader extends Vue {
    @Prop({
        type: String,
        required: true
    })
    endpoint: any;
    @Prop({
        type: Number,
        default: 1024
    })
    chunkSize: any;
    @Prop({
        type: String,
        default: ''
    })
    extAllowed: any;
    @Prop({
        type: Number,
        default: 1024
    })
    maxSizeAllowedKb: any;
    @Prop({
        type: Number,
        default: 3
    })
    maxParallelUpload: any;

    @Prop({
        required: true
    })
    attachmentArrayProp: Array<IChunkAttachment>;

    get chunkSizeInKb() {
        return this.chunkSize * 1024;
    }

    uploadPerc: number = 0;
    processedFiles: number = 0;
    totalFiles: number = 0;

    STATUS_INITIAL = 0;
    STATUS_SAVING = 1;
    STATUS_SUCCESS = 2;
    STATUS_FAILED = 3;

    uploadedFiles: Array<IChunkAttachment> = [];
    currentStatus: number = 0;
    uploadFieldName: string = '';
    uploadError: string = '';

    mounted() {
        this.reset();
    }

    deleteFile(index:number) {
        this.uploadedFiles.splice(index, 1);
        this.$emit('fileChanges', this.uploadedFiles);
    }

    compareFile(file1: IChunkAttachment, file2: IChunkAttachment) {
        let filename1 = file1.fileName.toUpperCase();
        let filename2 = file2.fileName.toUpperCase();

        if (filename1 < filename2) {
            return -1;
        }
        if (filename1 > filename2) {
            return 1;
        }

        return 0;
    }

    reset() {
        this.uploadFieldName = "attachments"
        this.currentStatus = this.STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = '';
        this.uploadPerc = 0;
        this.processedFiles = 0;
        this.totalFiles = 0;
    };

    filesChange(fileList: FileList) {
        this.currentStatus = this.STATUS_SAVING;
        let fileArray = Array.from(fileList);

        this.uploadError = '';
        this.uploadPerc = 0;
        this.processedFiles = 0;
        this.totalFiles = fileArray.length;

        fileArray.forEach(file => { 
            this.fileChange(file);
         });
                
    }

    fileChange(fileVal: any) {
        let checkFileAlreadyUploaded = this.isFileAlreadyUploaded(fileVal.name);
        if (checkFileAlreadyUploaded) {
            this.uploadError = this.uploadError + ' - ' + 'File ' + fileVal.name + ' already uploaded';
            this.onErrorNext();
            return;
        }
        let checkExt = this.checkAllowedExtensions(fileVal.name, this.extAllowed);
        if (!checkExt) {
            this.uploadError = this.uploadError + ' - ' + 'File ' + fileVal.name + ' has extension not allowed';
            this.onErrorNext();
            return;
        }
        let checkSize = this.checkSize(fileVal.size, this.maxSizeAllowedKb);
        if (!checkSize) {
            this.uploadError = this.uploadError + ' - ' + 'File ' + fileVal.name + ' exceeds maximum size allowed (' + this.showSize(this.maxSizeAllowedKb) + ')'
            this.onErrorNext();
            return;
        }
        if (fileVal.size == 0) {
            this.uploadError = this.uploadError + ' - ' + 'File ' + fileVal.name + ' empty'
            this.onErrorNext();
            return;
        }

        let chunksArray = this.createChunks(fileVal);
        let newFile: IChunkAttachment = {
            fileName: fileVal.name,
            processId: '',
            sessionId: '0',
            status: '',
            toDelete: false
        };
        this.upload(0, chunksArray, newFile);
    }

    onErrorNext() {
        this.processedFiles++;
        this.updateProgress();
        this.onEndUploading();
    }

    @Watch("uploadPerc")
    onEndUploading() {
        if(this.processedFiles == this.totalFiles) {
            this.currentStatus = this.STATUS_INITIAL;
            this.uploadedFiles.sort((f1, f2) => this.compareFile(f1, f2))
            if(this.uploadError !== '') {
                General.showAlertDanger(this.uploadError, this);
            }
            this.$emit('fileChanges', this.uploadedFiles);
        }
    }

    createChunks(file: any) {
        let chunks = Math.ceil(file.size / this.chunkSizeInKb);
        let chunksArray = []
        for (let i = 0; i < chunks; i++) {
            chunksArray.push({
                sent: false,
                content: file.slice(
                    i * this.chunkSizeInKb, Math.min(i * this.chunkSizeInKb + this.chunkSizeInKb, file.size), file.type
                )
            });
        }
        return chunksArray;
    }

    upload(nChunk: number, chunkArray: any, file: IChunkAttachment) {
        let app = this;
        if (nChunk >= chunkArray.length) {
            this.uploadedFiles.push(file);
            app.processedFiles++;
            app.updateProgress();
            return;
        }

        chunkArray[nChunk].sent = true;

        axios({
            method: 'post',
            data: this.formData(nChunk, chunkArray, file),
            url: General.GetApiUrl(this.endpoint),
            responseType: 'json',
            withCredentials: true,
            headers: {
                'Content-Type': 'application/octet-stream'
            },
        }).then(function (response: any) {
            if (nChunk == 0) {
                file.sessionId = response.data.sessionId;
            }
            if (response.data.processId) {
                file.processId = response.data.processId;
            }
                
            file.status = response.data.status;

            app.uploadBlock(nChunk, chunkArray, file);
        }).catch(error => {
            this.uploadError = this.uploadError + ' - ' + 'File ' + file.fileName + ' not uploaded: ' + error;
            this.onErrorNext();
        });
    }

    uploadBlock(nChunkStart: number, chunkArray: any, file: IChunkAttachment) {
        this.upload(nChunkStart + 1, chunkArray, file)
    }

    formData(nChunk: number, chunkArray: any, file: IChunkAttachment) {
        let formData = new FormData;
        let isLast: boolean = (chunkArray.length - 1 == nChunk);
        formData.set('is_last', (isLast).toString());
        formData.set('start_offset', (nChunk * this.chunkSizeInKb).toString());
        formData.set('session_id', file.sessionId.toString());
        formData.set('file', chunkArray[nChunk].content, `${file.fileName}.part`);
        return formData;
    }

    updateProgress() {
        let perc: number = Math.floor((this.processedFiles * 100) / (this.totalFiles));
        this.uploadPerc = perc;            
    }

    private showSize(sizeInKb: number): string {
        let sizeInByte = sizeInKb*1024;
        if (sizeInByte < 1024) return sizeInByte + ' Kb';
        return Math.floor(sizeInByte / 1024 / 1024) + ' Mb';
    }
    private getExtension(fileName: string): string {
        let nameSplitted = fileName.split('.');
        return nameSplitted[1];
    }
    private checkAllowedExtensions(fileName: string, extAllowed: string): boolean {
        if (extAllowed == '') return true;
        let extSplitted = extAllowed.split(',');
        let currentExt: string = this.getExtension(fileName);
        let find: boolean = false;
        extSplitted.forEach(function (ext: string) {
            if (ext.trim().toLowerCase() == currentExt.trim().toLowerCase()) {
                find = true;
            }
        });
        return find;
    }
    private checkSize(fileSizeByte: number, fileSizeAllowedKb: number): boolean {
        if (fileSizeByte > fileSizeAllowedKb  * 1024) return false;
        return true;
    }
    private isFileAlreadyUploaded(fileName: string) {
        let check = false;
        if((this.uploadedFiles.length > 0 && this.uploadedFiles.findIndex(f => f.fileName === fileName) >=  0)
            || (this.attachmentArrayProp.length > 0 && this.attachmentArrayProp.findIndex(f => f.fileName === fileName && !f.toDelete) >=  0))
            check = true;
        return check;
    }
}
